module.exports = __webpack_public_path__ + "static/media/convertir_artista_linea_3.d1a1091e.svg";